import { Route } from '@angular/router';
import { LOCALIZED_SHARED_ROUTES, SHARED_ROUTE_IDS } from '@lexplus-shared-lib';
import { IsLoggedInGuard } from '@lexplus-authentication';
import { AdminOnlyGuard } from '../../guards/admin-only.guard';

/**
 * The Stammdaten page and its five sub-pages. The parent loads the shell (header, left submenu, outlet);
 * every submenu item is a child route of its own, so it is linkable and survives a reload.
 */
export function StammdatenPageRoute(localeId: string): Route {
  const locale = localeId?.split('-')[0] || 'en';
  const path = (routeId: string): string => LOCALIZED_SHARED_ROUTES[routeId][locale];

  return {
    path: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA),
    loadComponent: () => import('./pages/stammdaten-page.component').then((m) => m.StammdatenPageComponent),
    canActivate: [IsLoggedInGuard, AdminOnlyGuard],
    data: { routeId: SHARED_ROUTE_IDS.ADMIN_MASTER_DATA },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_REGULATION_TYPES), // Default sub-page
      },
      {
        path: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_REGULATION_TYPES),
        loadComponent: () => import('./pages/erlasstypen-page/erlasstypen-page.component').then((m) => m.ErlasstypenPageComponent),
        data: { routeId: SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_REGULATION_TYPES },
      },
      {
        path: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_PUBLISHERS),
        loadComponent: () => import('./pages/herausgeber-page/herausgeber-page.component').then((m) => m.HerausgeberPageComponent),
        data: { routeId: SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_PUBLISHERS },
      },
      {
        path: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_INTERNATIONAL_PUBLISHERS),
        loadComponent: () =>
          import('./pages/internationale-herausgeber-page/internationale-herausgeber-page.component').then(
            (m) => m.InternationaleHerausgeberPageComponent,
          ),
        data: { routeId: SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_INTERNATIONAL_PUBLISHERS },
      },
      {
        path: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_LEGAL_AREAS),
        loadComponent: () => import('./pages/rechtsbereiche-page/rechtsbereiche-page.component').then((m) => m.RechtsbereichePageComponent),
        data: { routeId: SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_LEGAL_AREAS },
      },
      {
        path: path(SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_TOPIC_AREA_CATEGORIES),
        loadComponent: () =>
          import('./pages/themenbereich-kategorien-page/themenbereich-kategorien-page.component').then(
            (m) => m.ThemenbereichKategorienPageComponent,
          ),
        data: { routeId: SHARED_ROUTE_IDS.ADMIN_MASTER_DATA_TOPIC_AREA_CATEGORIES },
      },
    ],
  };
}
